module.exports = __webpack_public_path__ + "img/closed-loop-3.e2fe9dc8.png";